import Api from './api';

const CargosService = {
    cadastro: async (params) => {
        const response = await Api.post('/cargos/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/cargos/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletar: (id) => {
        Api.delete(`/cargos/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    buscar: (params) => {
        const response = Api.get(`/cargos/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    cargoEdit: async (id) => {
        const response = await Api.get(`/cargos/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/cargos/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    }
}

export default CargosService;